import { Card } from "@mui/material";
import HeroLogo from "../../Shared/HeroLogo/HeroLogo";
function SplashHeader() {
  return (
    <Card sx={{ width: '100%' }}>
      <HeroLogo />
    </Card>
  );
}
export default SplashHeader; 